export default defineNuxtPlugin({
  async setup() {
    const { $auth, $i18n, $api, $config, $t, $customGtm, $configsArray } = useNuxtApp();
    const cookieControl = useCookieControl();

    const themeCookie = useCookie<boolean>('alternate-theme', {
      path: '/',
      maxAge: 60 * 60 * 24 * 30 * 12,
    });
    const globals = reactive({
      configs: {} as { [key: string]: any },
      customClass: '',
      currentPlayingVideo: null,
      videoAutoPlayEnabled: true,
      assetsArr: [] as any[],
      global: [] as any[],
      header: [],
      footer: [],
      userMenu: [],
      // images: {},
      links: {} as { [key: string]: any },
      enabledFeatures: {} as { [key: string]: any },
      avatarList: [] as any[],
      colors: '',
      enabledExpirationPopup: {},
      customStyle: null,
      customPlan: {},
      previousRoutes: [],
      metaData: {},
      priceFormat: {},
      alternatTheme: false,
      colorsConfigs: [] as any[],
      deskSetting: [],
      mobSetting: [],
      isDarkDefault: false,
      cookies: [] as any[],
      consentCookie: true,
      popups: [],
      footerCustomProperties: {},
      headerCustomProperties: {} as { [key: string]: any },
      isConfigLoaded: false,
      googleAdsConfiguration: {},
      redirectDisclaimer: [],
      parentalControlSendgridConfig: {},
      refreshMonsooqSubscriptions: false,
      paymentMetaData: {},
      loginMetaData: {},
      topBannerHeight: 0,
      tabNameSeo: {} as { [key: string]: any },
      loginOptions: '',
      currentLocale:{},
      navigationItems:[] as any[],
    });
    const isLoggedIn = computed<boolean>(() => {
      return $auth.isLoggedIn;
    });
    const darkThemeActive = computed<boolean>({
      get() {
        if (globals.isDarkDefault && !globals.alternatTheme) {
          return true;
        } else if (!globals.isDarkDefault && !globals.alternatTheme) {
          return false;
        } else if (!globals.isDarkDefault && globals.alternatTheme) {
          return true;
        } else {
          return false;
        }
      },
      set(value) {
        globals.alternatTheme = !globals.alternatTheme;
      },
    });
    const images = computed<{ [key: string]: string }>(() => {
      let images = {};
      if (globals.assetsArr && Array.isArray(globals.assetsArr)) {
        images = globals.assetsArr.reduce(
          (obj, value) => {
            obj[value.data.title] =
              globals.alternatTheme &&
                value.data.customProperties &&
                value.data.customProperties['alternativeTheme']
                ? value.data.customProperties['alternativeTheme']
                : value.data.imageUrl;
            return obj;
          },
          {} as {
            [key: string]: string;
          },
        );
      } else {
        images = {};
      }
      return images;
    });
    const currentLocale = computed<any>(() => {
      let tenantLocale =
        $config.public.locale.baseLocales.find(
          (l: any) => l.code == $i18n.locale.value,
        );

      return tenantLocale;
    });
    const isPopupBlockerActivated = (popupWindow: any) => {
      if (popupWindow) {
        if (/chrome/.test(navigator.userAgent?.toLowerCase())) {
          try {
            popupWindow.focus();
          } catch (e) {
            return true;
          }
        } else {
          popupWindow.onload = function () {
            return popupWindow.innerHeight > 0 === false;
          };
        }
      } else {
        return true;
      }
      return false;
    };
    const getConfigurations = async () => {
      if (globals.isConfigLoaded) {
        return;
      }
      let configs: any[];
      // if (this.$store.state.configs) {
      //   let res = new Promise((resolve) => {
      //     setTimeout(() => resolve(this.$store.state.configs), 0);
      //   });
      //   configs = await res;
      // } else {
      const self = this;
      await $api.endPoints.getDeviceInfo();
      // configs = await this.$cacheFetch(
      //   {
      //     key:
      //       'configKey-' +
      //       this.$axios.defaults.headers.common['X-Tenant-ID'] +
      //       '-' +
      //       this.$i18n.localeProperties.code +
      //       '-' +
      //       self.$api.endPoints.operatingSystem,
      //     expire: 60 * 60 * 1,
      //   },
      //   async () => {
      //     return await self.$api.endPoints.getStructure(
      //       `configurations`,
      //       {},
      //       undefined,
      //       true
      //     );
      //   }
      // );
      configs = $configsArray
      const configsObj = configs.reduce((obj, item) => {
        obj[item.name] = item;
        return obj;
      }, {});
      globals.configs = configsObj;
      globals.assetsArr =
        (globals.configs.configurations_images &&
          globals.configs.configurations_images.substructure) ||
        [];
      globals.global =
        (globals.configs.configurations_global &&
          globals.configs.configurations_global.substructure) ||
        [];
      globals.header =
        (globals.configs.configurations_header &&
          globals.configs.configurations_header.substructure) ||
        [];
      globals.headerCustomProperties =
        globals.configs.configurations_header.data.customProperties || {};
      globals.footer =
        (globals.configs.configurations_footer &&
          globals.configs.configurations_footer.substructure) ||
        [];
      globals.footerCustomProperties =
        globals.configs.configurations_header.data.customProperties || {};
      globals.userMenu =
        (globals.configs.configurations_profilemenu &&
          globals.configs.configurations_profilemenu.substructure) ||
        [];
      globals.deskSetting =
        (globals.configs.configurations_settingmenu &&
          globals.configs.configurations_settingmenu.substructure) ||
        [];
      globals.mobSetting =
        (globals.configs.configurations_mobilesetting &&
          globals.configs.configurations_mobilesetting.substructure) ||
        [];
      globals.cookies = (globals.configs.configurations_cookies &&
        globals.configs.configurations_cookies.substructure) || [0, 1, 2, 3];

      globals.consentCookie = globals.configs.configurations_cookies
        ? globals.configs.configurations_cookies.data?.customProperties
          ?.consentCookie
        : true;

      globals.popups =
        (globals.configs.configurations_popups &&
          globals.configs.configurations_popups.substructure) ||
        [];
        globals.navigationItems =
        (globals.configs.configurations_global &&
          globals.configs.configurations_global.substructure?.length &&globals.configs.configurations_global.substructure.find((sub:any)=>sub?.data?.title==='Navigation')?.substructure  ) ||
        [];

      if (globals.global && Array.isArray(globals.global)) {
        let linksObj = globals.global.find(
          (struct) => struct.name == 'global_shared_links',
        );
        let enabledFeaturesObj = globals.global.find(
          (struct) => struct.name == 'enabled_features',
        );
        let avatarListObj = globals.global.find(
          (struct) => struct.name == 'avatar_list',
        );


        let enabledExpirationPopupObj = globals.global.find(
          (struct) => struct.name == 'enable_ExpirationPopup',
        );
        const customStyling = globals.global.find(
          (struct) => struct.name == 'custom_styling',
        );

        let googleAdsConfiguration = globals.global.find(
          (struct) => struct.name == 'google-ads',
        );
        let redirectDisclaimer = globals.global.find(
          (struct) => struct.name == 'external_redirect_disclaimer',
        );
        let parentalControlSendgridConfig = globals.global.find(
          (struct) => struct.name == 'parental-control-sendgrid-config',
        );

        globals.customPlan = globals.global.find(
          (struct) => struct.name == 'custom_plan',
        )?.data?.customProperties;

        let tabsSeo = globals.global.find(
          (struct) => struct.name == 'tab_names_seo',
        );

        let loginOptions = globals.global.find(
          (struct) => struct.name == 'login_options',
        );

        globals.tabNameSeo = tabsSeo ? tabsSeo.data.customProperties : {};

        globals.links = linksObj ? linksObj.data.customProperties : {};

        globals.enabledFeatures = enabledFeaturesObj
          ? enabledFeaturesObj.data.customProperties
          : {};

        globals.avatarList = avatarListObj
          ? avatarListObj.data.customProperties
          : [];

        globals.enabledExpirationPopup = enabledExpirationPopupObj
          ? enabledExpirationPopupObj.data.customProperties
          : {};

        globals.googleAdsConfiguration = googleAdsConfiguration
          ? googleAdsConfiguration.data.customProperties
          : {};
        globals.redirectDisclaimer = redirectDisclaimer
          ? redirectDisclaimer.data
          : {};
        globals.parentalControlSendgridConfig = parentalControlSendgridConfig
          ? parentalControlSendgridConfig.data.customProperties
          : {};

        globals.loginOptions = loginOptions
          ? loginOptions.data?.customProperties
          : [];
        globals.metaData = globals.global.find(
          (struct) => struct.name == 'meta_data',
        )?.data?.customProperties;
        globals.priceFormat = globals.global.find(
          (struct) => struct.name == 'price_format',
        )?.data?.customProperties;
        globals.paymentMetaData = globals.global.find(
          (struct) => struct.name == 'payment_meta_data',
        )?.data?.customProperties;
        globals.loginMetaData = globals.global.find(
          (struct) => struct.name == 'login_meta_data',
        )?.data?.customProperties;
        if (customStyling && customStyling.data.customProperties) {
          globals.customStyle = customStyling.data.customProperties.cdnLink;
        }
      } else {
        globals.links = {};
        globals.enabledFeatures = {};
        globals.avatarList = {};
        globals.customPlan = {};
        globals.enabledExpirationPopup = {};
        globals.metaData = {};
        globals.priceFormat = {};
        globals.paymentMetaData = {};
        globals.loginMetaData = {};
      }
      globals.colorsConfigs =
        (globals.configs.configurations_colors &&
          globals.configs.configurations_colors.substructure) ||
        [];
      globals.isDarkDefault =
        globals.colorsConfigs[0]?.data?.customProperties?.isDark;
      setColors();
      cookieControl.isConsentGiven.value =
        globals.consentCookie === 'false'
          ? true
          : cookieControl.isConsentGiven.value;
      cookieControl.cookiesEnabled.value =
        cookieControl.cookiesEnabled.value || [];
      cookieControl.cookiesEnabledIds.value =
        cookieControl.cookiesEnabledIds.value || [];
      cookieControl.moduleOptions.cookies.necessary = [];
      cookieControl.moduleOptions.cookies.optional = [];
      globals.cookies.forEach((c, i) => {
        if (c?.data?.customProperties?.necessary) {
          cookieControl.moduleOptions.cookies.necessary.push({
            name: $t(c?.data?.title) || $t(`cookies.${i}.name`),
            description: c?.data?.subTitle || $t(`cookies.${i}.description`),
            identifier: c?.data?.customProperties?.identifier || i,
          });
        } else {
          cookieControl.moduleOptions.cookies.optional.push({
            name: $t(c?.data?.title) || $t(`cookies.${i}.name`),
            description: c?.data?.subTitle || $t(`cookies.${i}.description`),
            identifier: c?.data?.customProperties?.identifier || i,
            initialState: c?.data?.customProperties?.initialState == 'true',
            accepted: () => {
              window.dataLayer = window.dataLayer || [];
              function gtag() {
                dataLayer.push(arguments);
              }
              gtag('js', new Date());
              gtag('config', `${$customGtm?.id}`);
            },
          });
        }
      });
      globals.isConfigLoaded = true;

      if (globals?.enabledFeatures?.externalFooter == 'true') {
        globals.configs.fragments_externalFooter =
          await $api.endPoints.getStructure(
            `fragments_externalFooter`,
            {},
            undefined,
            true,
          );
      }
    };
    const setColors = () => {
      let colorTheme;
      if (!globals.colorsConfigs.length) {
        colorTheme = globals.colorsConfigs[0];
      }
      if (globals.colorsConfigs.length === 1) {
        colorTheme = globals.colorsConfigs[0];
      }
      if (globals.colorsConfigs.length === 2) {
        colorTheme = globals.alternatTheme
          ? globals.colorsConfigs[1]
          : globals.colorsConfigs[0];
      }
      if (colorTheme?.data?.customProperties) {
        const props = colorTheme.data.customProperties;
        let cssString = Object.entries<string>(props).reduce(
          (old: string, current: [string, string]) => {
            old += `${current[0]}: ${current[1]};\n`;
            return old;
          },
          '',
        );
        globals.colors = cssString;
      }
    };

    // await getConfigurations();    
    if (import.meta.client) {
      watch(
        () => globals.alternatTheme,
        () => {
          themeCookie.value = globals.alternatTheme;
          setColors();          
          if (isLoggedIn.value) {
            $api.endPoints.selectUserTheme(globals.alternatTheme);
          }
        },
      );
    
      watch(
        () => $auth.isLoggedIn,
        async (e) => {
          if (e) {
            const { alternatTheme } = await $api.endPoints.checkUserTheme();
            globals.alternatTheme = alternatTheme;
            const {selectedLang} = await $api.endPoints.checkUserLocale();
         
            if(selectedLang?.lang !== currentLocale.value.code){
              $i18n.setLocale(selectedLang?.lang);
              globals.currentLocale=  $config?.public?.locale?.baseLocales?.find(
                (l: any) => l.code == selectedLang?.lang,
              )|| {};
            }
          } else {
            globals.alternatTheme = themeCookie.value;
          }
        },
        {
          immediate: true,
        },
      );
    }
    globals.darkThemeActive = darkThemeActive;
    globals.images = images;
    globals.getConfigurations = getConfigurations;
    globals.currentLocale = currentLocale;
    globals.isLoggedIn = isLoggedIn;
    globals.isPopupBlockerActivated = isPopupBlockerActivated;

    await getConfigurations();
    return {
      provide: {
        // globals: reactive({
        //   data,
        //   isPopupBlockerActivated,
        //   // isLoggedIn,
        //   darkThemeActive,
        //   images,
        //   getConfigurations
        //   // currentLocale,
        // })
        globals,
      },
    };
  },
});
